/**
 * Downloads a file from a Response object by triggering a browser download.
 */
export async function downloadBlobResponse(
  baseQueryReturnValue: Response,
  filename: string = 'downloaded',
): Promise<void> {
  const blob = await baseQueryReturnValue.blob();
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
}
